<template>
  <div class="member_bill_wrap">
    <LoadingMask v-if="requestLoading" />
    <template v-else>
      <ImmersionHeader
        ref="ImmersionHeader"
        :uiTheme="'globalOne'"
        :title="$t('FoodC_bill_QiYn_xBng')"
        leftIconClassName="icon-v3_outlined_back"
        :blackTheme="false"
        @BackCK="BackCK"
      />
      <!-- 饼图&总节省金额 -->
      <amountPie :headerHeight="headerHeight" :savingMoneyCount="savingMoneyCount" />
      <!-- 节省金额明细 -->
      <card
        class="card_wrap_margin"
        :headerHeight="headerHeight"
        :savingMoneyCount="savingMoneyCount"
      />
    </template>
  </div>
</template>

<script>
import mixin from '@/page/member/mixins.js'
import ImmersionHeader from '@/components/immersionHeader/index.vue'
import amountPie from '../components-v2/memberSavings/amount-pie.vue'
import card from '../components-v2/memberSavings/card.vue'
import { getMembershipSavingMoneyCount } from '@/api/member/index.js'
import trackEvent from '@/common/js/track'
import LoadingMask from '@/components/loading/loading-mask.vue'
export default {
  name: 'MemberBill',
  components: {
    amountPie,
    card,
    ImmersionHeader,
    LoadingMask,
  },
  mixins: [mixin],
  props: {},
  data() {
    return {
      headerHeight: 0,
      savingMoneyCount: {},
      requestLoading: false,
    }
  },
  computed: {},
  mounted() {
    this.getHeaderHeight()
    this.getInit()
  },
  methods: {
    BackCK() {
      window.history.go(-1)
    },
    // 动态获取顶部导航条高度 （不同手机不一致）
    getHeaderHeight() {
      this.headerHeight = this.$refs?.ImmersionHeader?.$el?.offsetHeight || 0
    },
    async getInit() {
      this.requestLoading = true
      try {
        const res = await getMembershipSavingMoneyCount()
        const { data } = res || {}
        if (data?.errno === 0) {
          const countData = data.data ?? {}
          this.savingMoneyCount = countData
          // 埋点上报
          trackEvent({
            eventId: 'sailing_c_x_membership_savingpage_sw',
            eventLabel: '会员已省明细页面曝光',
            attrs: {
              totalsaving: countData.totalSavingMoneyTran,
              foodsaving: countData.foodSavingMoneyTran,
              grocerysaving: countData.shopSavingMoneyTran,
              ridesaving: countData.rideSavingMoneyTran,
              entregasaving: countData.entregaSavingMoneyTran,
            },
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.requestLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.member_bill_wrap {
  background-color: #f5f5f5;
  min-height: 100vh;
  overflow: hidden;
  scrollbar-width: none;
  .card_wrap_margin {
    margin-top: -53px;
  }
}
</style>
